import { TThunkAction } from '../../types/redux';
import {
  TSetQuestionAnswerReactionWebResponse,
  fetchSetQuestionAnswerReactionWeb,
} from '../../repositories/newbuilding-reviews/v1/set-question-answer-reaction-web';
import { EType } from '../../repositories/newbuilding-reviews/entities/set_answer_reaction/SetAnswerReactionRequest';
import { EStatus } from '../../types/likes';
import { setAnswerReactionAction } from './actions';
import { mapLabelFromState, trackReactionAnalyticClick } from '../answers/analytics/reactionAnalytic';
import { getAnswerById } from '../../selectors/answers';
import { getNewbuildingRating } from '../../selectors/newbuildingInfo';
import { ISetAnswerReactionWebResponse } from '../../repositories/newbuilding-reviews/entities/set_answer_reaction/SetAnswerReactionWebResponse';

interface IParams {
  answerId: string;
  type: EStatus;
}

export function setQuestionAnswerReaction({ answerId, type }: IParams): TThunkAction<Promise<boolean>> {
  return async (dispatch, getState, context) => {
    const { logger, httpApi } = context;

    const siteType = context.custom.deviceType;
    const state = getState();
    const { like } = getAnswerById(answerId)(state);
    const rating = getNewbuildingRating(state);

    try {
      const { response }: TSetQuestionAnswerReactionWebResponse = await fetchSetQuestionAnswerReactionWeb({
        httpApi,
        parameters: { answerId, type: type as unknown as EType },
      });

      dispatch(
        setAnswerReactionAction({
          answerId,
          type: (response as ISetAnswerReactionWebResponse).type as unknown as EStatus,
        }),
      );

      const label = mapLabelFromState({
        currentState: like.status,
        nextState: (response as ISetAnswerReactionWebResponse).type as unknown as EStatus,
      });
      const page = {
        offerType: 'JK',
        pageType: 'ReviewsJK',
        siteType,
        extra: {
          rating,
          review_id: answerId,
          type: 'answer_to_question',
        },
      };
      trackReactionAnalyticClick({ label, page });

      return true;
    } catch (error) {
      logger.error(error, {
        domain: 'question#setQuestionAnswerReaction',
        message: error.message,
      });

      return false;
    }
  };
}
